import React, {FC} from 'react';
import {Card, CardContent, ListItem, List, CardFooter, Badge, Icon} from "framework7-react";
import {useTranslation} from "react-i18next";
import './User.css'
interface UserProps {
    userData?: any;
    atag: string;
}
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
export const User: FC <UserProps> = ({userData, atag}) => {
    const {t} = useTranslation();
    return (
        <Card title={t('profile.titleUser')} className='user-block'>
            <CardContent padding={false}>
                <List dividersIos mediaList outlineIos strongIos>
                    <ListItem
                    >
                        <img
                            slot="media"
                            src={toAbsoluteUrl('/img/icons/userPhoto.png')}
                            width="80"
                        />
                        <div className='user-block-info'>
                            <div>
                                <Icon material="account_circle" slot="media" />
                                <span className='user-block-info-item'>{userData?.email}</span>
                            </div>
                            <div className='user-block-info-phone'>
                                <Icon material="call"></Icon>
                                <span className='user-block-info-item'>+254703456020</span>
                            </div>
                        </div>
                    </ListItem>
                </List>
            </CardContent>
            <CardFooter>
                 <span>
                    <Badge
                        slot="after"
                        color={userData?.is_active ? 'green' : 'red'}
                    >
                        {userData?.is_active ? `${t("profile.statusActive")}` : `${t("profile.statusNotActive")}`}
                    </Badge>
                </span>
                <span>{atag}</span>
            </CardFooter>
        </Card>
    )
}